module.exports = __webpack_public_path__ + "static/media/heart-attack-first-lithonia-medical-center.74cf1df5.jpg";